var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide-card"},[_c('div',{staticClass:"guide-card-header"},[_c('div',{staticClass:"guide-card-toolbox-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("tool")],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }